/**
 * Upside Drinks · Custom selling plan selector v2
 *
 * State preservation: sessionStorage + class on <html>.
 * theme.liquid has an inline script that restores the class before body parses,
 * and CSS in <head> keeps the card expanded purely via that class.
 */
(function () {
  'use strict';

  var C = 'ud-sp-sub-active';
  var MONTHS = ['January','February','March','April','May','June',
                'July','August','September','October','November','December'];

  function save(on) {
    if (on) {
      sessionStorage.setItem('ud-sp-active', 'subscribe');
      document.documentElement.classList.add(C);
    } else {
      sessionStorage.removeItem('ud-sp-active');
      document.documentElement.classList.remove(C);
    }
  }

  function bootAll() {
    var els = document.querySelectorAll('[data-ud-selling-plans]:not([data-ud-ok])');
    for (var i = 0; i < els.length; i++) init(els[i]);
  }

  bootAll();
  document.addEventListener('shopify:section:load', bootAll);

  new MutationObserver(function (m) {
    for (var i = 0; i < m.length; i++) {
      for (var j = 0; j < m[i].addedNodes.length; j++) {
        var n = m[i].addedNodes[j];
        if (n.nodeType === 1 && (n.hasAttribute('data-ud-selling-plans') ||
            (n.querySelector && n.querySelector('[data-ud-selling-plans]')))) {
          bootAll(); return;
        }
      }
    }
  }).observe(document.body, { childList: true, subtree: true });

  function init(el) {
    el.setAttribute('data-ud-ok', '');
    var opts  = el.querySelectorAll('[data-sp-option]');
    var input = el.querySelector('[data-sp-input]');
    var freq  = el.querySelector('[data-sp-frequency]');
    var pOne  = el.querySelector('[data-sp-onetime-price]');
    var pSub  = el.querySelector('[data-sp-subscribe-price]');
    var pComp = el.querySelector('[data-sp-compare-price]');
    var sLine = el.querySelector('[data-sp-savings]');
    var nDel  = el.querySelector('[data-sp-next-delivery]');
    var cta   = el.querySelector('[data-sp-cta]');
    if (!input) return;

    // Compute next delivery date
    updateNextDelivery();

    // Restore subscribe state
    if (sessionStorage.getItem('ud-sp-active') === 'subscribe') {
      el.style.setProperty('--ud-sp-transition', 'none');
      activate(el, opts, 'subscribe');
      if (freq) freq.selectedIndex = +(sessionStorage.getItem('ud-sp-freq') || 0);
      input.value = freq ? freq.value : '';
      save(true);
      toggleCta(true);
      updateNextDelivery();
      requestAnimationFrame(function () {
        el.style.removeProperty('--ud-sp-transition');
      });
    }

    // If one-time is hidden, subscribe is active by default (set by Liquid)
    var onetimeHidden = !el.querySelector('[data-sp-option="onetime"]');
    if (onetimeHidden && !isSubscribe) {
      // First load with one-time hidden: activate subscribe + set selling plan
      input.value = freq ? freq.value : '';
      updateNextDelivery();
    }

    // CTA button helper
    function toggleCta(isSubscribe) {
      if (!cta) return;
      if (isSubscribe) {
        cta.classList.add('ud-sp__cta--visible');
      } else {
        cta.classList.remove('ud-sp__cta--visible');
      }
    }

    // Click handlers
    for (var i = 0; i < opts.length; i++) {
      opts[i].addEventListener('click', (function (opt) {
        return function () {
          activate(el, opts, opt.dataset.spOption);
          if (opt.dataset.spOption === 'subscribe') {
            save(true); input.value = freq.value;
            toggleCta(true);
          } else {
            save(false); input.value = '';
            toggleCta(false);
          }
        };
      })(opts[i]));
    }

    // CTA click: submit the product form with selling plan
    if (cta) {
      cta.addEventListener('click', function () {
        var form = document.getElementById(input.getAttribute('form'));
        if (!form) return;
        // Ensure selling plan is set
        if (!input.value && freq) input.value = freq.value;
        // Find and click the add-to-cart button or submit the form
        var addBtn = form.querySelector('[type="submit"], .btn--add-to-cart, [name="add"]');
        if (addBtn) { addBtn.click(); } else { form.submit(); }
      });
    }

    if (freq) {
      freq.addEventListener('change', function () {
        sessionStorage.setItem('ud-sp-freq', freq.selectedIndex);
        if (el.querySelector('.ud-sp__option--active[data-sp-option="subscribe"]')) {
          input.value = freq.value;
          var sel = freq.options[freq.selectedIndex];
          if (sel && sel.dataset.planPrice && pSub) pSub.textContent = sel.dataset.planPrice;
        }
        updateNextDelivery();
      });
    }

    function parseInterval(text) {
      // Parse delivery interval from plan option text.
      // Examples: "Deliver every 2 weeks" → {unit:'WEEK',count:2}
      //           "Deliver every month"   → {unit:'MONTH',count:1}
      //           "Every 3 months"        → {unit:'MONTH',count:3}
      var t = (text || '').toLowerCase();
      var num = 1;
      var m = t.match(/(\d+)/);
      if (m) num = parseInt(m[1], 10);
      if (t.indexOf('year') > -1) return { unit: 'YEAR', count: num };
      if (t.indexOf('month') > -1) return { unit: 'MONTH', count: num };
      if (t.indexOf('week') > -1) return { unit: 'WEEK', count: num };
      if (t.indexOf('day') > -1) return { unit: 'DAY', count: num };
      return { unit: 'MONTH', count: 1 };
    }

    function updateNextDelivery() {
      if (!nDel || !freq) return;
      var sel = freq.options[freq.selectedIndex];
      if (!sel) return;
      // Try data attributes first, fall back to parsing option text
      var interval = sel.dataset.interval;
      var count = sel.dataset.intervalCount;
      if (!interval || interval === '') {
        var parsed = parseInterval(sel.textContent);
        interval = parsed.unit;
        count = parsed.count;
      } else {
        interval = interval.toUpperCase();
        count = parseInt(count || '1', 10);
      }
      var d = new Date();
      if (interval === 'WEEK') {
        d.setDate(d.getDate() + count * 7);
      } else if (interval === 'MONTH') {
        d.setMonth(d.getMonth() + count);
      } else if (interval === 'DAY') {
        d.setDate(d.getDate() + count);
      } else if (interval === 'YEAR') {
        d.setFullYear(d.getFullYear() + count);
      }
      nDel.textContent = 'Next delivery: ' + MONTHS[d.getMonth()] + ' ' + d.getDate();
    }

    // Variant changes
    var sec = el.closest('.shopify-section');
    function onVariant(e) {
      var v = e.detail && e.detail.variant;
      if (!v) return;
      if (pOne && v.price != null) pOne.textContent = money(v.price);
      if (pComp && v.price != null) pComp.textContent = money(v.price);
      if (v.selling_plan_allocations && v.selling_plan_allocations.length) {
        el.style.display = '';
        syncAlloc(v.selling_plan_allocations, v.price);
      } else {
        el.style.display = 'none'; input.value = '';
      }
    }
    if (sec) sec.addEventListener('variant:change', onVariant);
    document.addEventListener('variant:change', onVariant);

    var form = document.getElementById(input.getAttribute('form'));
    if (form) {
      var vid = form.querySelector('select[name="id"],input[name="id"]');
      if (vid) {
        function onVid() {
          var pj = document.querySelector('[data-product-json]');
          if (!pj) return;
          try {
            var p = JSON.parse(pj.textContent);
            var v = p.variants.find(function (x) { return String(x.id) === String(vid.value); });
            if (!v) return;
            if (pOne) pOne.textContent = money(v.price);
            if (pComp) pComp.textContent = money(v.price);
            if (v.selling_plan_allocations && v.selling_plan_allocations.length) {
              el.style.display = '';
              syncAlloc(v.selling_plan_allocations, v.price);
            } else { el.style.display = 'none'; input.value = ''; }
          } catch (e) {}
        }
        new MutationObserver(onVid).observe(vid, { attributes: true, attributeFilter: ['value'] });
        vid.addEventListener('change', onVid);
      }
    }

    function syncAlloc(allocs, variantPrice) {
      if (!freq) return;
      var fopts = freq.querySelectorAll('option');
      for (var i = 0; i < fopts.length; i++) {
        if (allocs[i]) fopts[i].dataset.planPrice = money(allocs[i].per_delivery_price);
      }
      var idx = freq.selectedIndex;
      if (allocs[idx]) {
        if (pSub) pSub.textContent = money(allocs[idx].per_delivery_price);
        if (sLine && variantPrice != null) {
          var fmt = sLine.dataset.spSavingsFormat || 'dollar';
          var tmpl = sLine.dataset.spSavingsTemplate || 'Save __ today';
          var val;
          if (fmt === 'percentage') {
            val = (sLine.dataset.spDiscountPct || '5') + '%';
          } else {
            val = money(variantPrice - allocs[idx].per_delivery_price);
          }
          sLine.textContent = tmpl.replace('__', val);
        }
      }
    }
  }

  function activate(el, opts, which) {
    for (var i = 0; i < opts.length; i++) {
      var on = opts[i].dataset.spOption === which;
      opts[i].classList.toggle('ud-sp__option--active', on);
      opts[i].querySelector('.ud-sp__radio').checked = on;
    }
  }

  function money(c) {
    if (typeof c === 'string') c = parseInt(c, 10);
    return '$' + (c / 100).toFixed(2);
  }
})();
